import { __esm, __export, __toCommonJS } from "./chunk-U7HSCTZN.mjs"; // src/middleware/cancel/Cancel.js

var Cancel_exports = {};

__export(Cancel_exports, {
  default: function _default() {
    return Cancel_default;
  }
});

function Cancel(message) {
  this.message = message;
}

var Cancel_default;

var init_Cancel = __esm({
  "src/middleware/cancel/Cancel.js": function srcMiddlewareCancelCancelJs() {
    Cancel.prototype.toString = function toString() {
      return "Cancel".concat(this.message ? ": ".concat(this.message) : "");
    };

    Cancel.prototype.__CANCEL__ = true;
    Cancel_default = Cancel;
  }
}); // src/middleware/promise.js


init_Cancel(); // src/middleware/cancel/CancelToken.js

var Cancel2 = (init_Cancel(), __toCommonJS(Cancel_exports));

function CancelToken(executor) {
  var _this = this;

  if (typeof executor !== "function") {
    throw new TypeError("executor must be a function.");
  }

  var resolvePromise = null;
  this.promise = new Promise(function (resolve) {
    resolvePromise = resolve;
  });
  executor(function (message) {
    if (_this.reason) {
      return;
    }

    _this.reason = new Cancel2(message);
    resolvePromise(_this.reason);
  });
}

CancelToken.source = function () {
  var cancel;
  var token = new CancelToken(function (can) {
    cancel = can;
  });
  return {
    token: token,
    cancel: cancel
  };
};

var CancelToken_default = CancelToken; // src/middleware/cancel/isCancel.js

var isCancel_default = function isCancel_default(value) {
  return !!(value && value.__CANCEL__);
}; // src/middleware/promise.js


var globalPromise = typeof Promise === "function" && Promise;

var promise = function promise() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var Promise2 = options.implementation || globalPromise;

  if (!Promise2) {
    throw new Error("`Promise` is not available in global scope, and no implementation was passed");
  }

  return {
    onReturn: function onReturn(channels, context) {
      return new Promise2(function (resolve, reject) {
        var cancel = context.options.cancelToken;

        if (cancel) {
          cancel.promise.then(function (reason) {
            channels.abort.publish(reason);
            reject(reason);
          });
        }

        channels.error.subscribe(reject);
        channels.response.subscribe(function (response) {
          resolve(options.onlyBody ? response.body : response);
        });
        setTimeout(function () {
          try {
            channels.request.publish(context);
          } catch (err) {
            reject(err);
          }
        }, 0);
      });
    }
  };
};

promise.Cancel = Cancel_default;
promise.CancelToken = CancelToken_default;
promise.isCancel = isCancel_default;
var promise_default = promise;
export { promise_default };